namespace HA.Core.HTML {
    //noinspection TsLint
    export class GMap extends Div {

        protected createSelf() {
            super.createSelf();
            //this.addToData("center", this.get("center"));
            //const center: google.maps.LatLngLiteral = {lat: this.get("lat"), lng: this.get("lng")};
            const map: google.maps.Map = new google.maps.Map(this.getElement(), {
                center: this.get("center"),
                zoom: this.get("zoom")
            });

            new google.maps.Marker({
                position: this.get("center"),
                map: map,
            });
        }
    }
}
